<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a  class="logo logo-dark">
          <span class="">
            <img src="assets/images/logo123.png" alt="Logo" height="60">
          </span>
        </a>
      </div>
      @if (!isProdEnv) {
        <div class="env-label-preprod" title="You are currently in the Pre-Production environment">
          <i class="mdi mdi-alert-decagram-outline me-1"></i>
          Pre-Production
        </div>
      }

      <button type="button" class="btn btn-sm px-3 font-size-16 vertinav-toggle header-item waves-effect"
        id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <button type="button"
        class="btn btn-sm px-3 font-size-16 horinav-toggle header-item waves-effect waves-light"
        data-bs-toggle="collapse" data-bs-target="#topnav-menu-content" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <!-- <form class="app-search d-none d-lg-block">
      <div class="position-relative">
        <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">
        <span class="mdi mdi-magnify"></span>
      </div>
    </form> -->
  </div>

  <div class="d-flex">

    <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
      <button type="button" class="btn header-item noti-icon waves-effect" ngbDropdownToggle id="page-header-search-dropdown"
        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="mdi mdi-magnify"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
        aria-labelledby="page-header-search-dropdown">

        <form class="p-3">
          <div class="form-group m-0">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}"
                aria-label="Recipient's username">
              <div class="input-group-append">
                <button class="btn btn-primary" type="submit"><i
                class="mdi mdi-magnify"></i></button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="dropdown d-none d-lg-inline-block ms-1">
      <button type="button" class="btn header-item noti-icon waves-effect" data-toggle="fullscreen"
        (click)="fullscreen()">
        <i class="mdi mdi-fullscreen"></i>
      </button>
    </div>

    <div class="dropdown d-inline-block ms-1" ngbDropdown>
      <button type="button" class="btn header-item noti-icon waves-effect" ngbDropdownToggle
        id="page-header-theme-dropdown" aria-haspopup="true" aria-expanded="false" title="Change theme">
        <i class="mdi mdi-palette-outline"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="page-header-theme-dropdown">
        @for (t of themeService.themes; track t.id) {
          <button type="button" class="dropdown-item d-flex align-items-center justify-content-between"
            (click)="themeService.setTheme(t.id)">
            <span>{{ t.label }}</span>
            @if (themeService.getTheme() === t.id) {
              <i class="mdi mdi-check text-primary"></i>
            }
          </button>
        }
      </div>
    </div>

    <!-- Notification Icon -->
    <div class="dropdown d-inline-block ms-1" style="position: relative;">
      <app-notification-icon
        (notificationClick)="onNotificationIconClick()">
      </app-notification-icon>

      <app-notification-dropdown
        [(visible)]="showNotificationDropdown"
        (visibleChange)="onNotificationDropdownVisibleChange($event)"
        (notificationClick)="onNotificationClick($event)">
      </app-notification-dropdown>
    </div>

    <div class="dropdown d-inline-block" ngbDropdown>
      <button type="button" class="btn header-item waves-effect" ngbDropdownToggle
        id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <img class="rounded-circle header-profile-user" src="assets/images/users/avatar-1.png"
          alt="Header Avatar">
        <span class="d-none d-xl-inline-block ms-1">{{userName}}</span>
        <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
        <!-- item-->
        <h6 class="dropdown-header">welcome {{userName  | translate}}</h6>
        <a class="dropdown-item" (click)="openProfileModal(largeDataModal)" href="javascript: void(0);"><i
        class="mdi mdi-account-circle text-muted font-size-16 align-middle me-1" ></i> <span
      class="align-middle" key="t-profile" >{{ 'HEADER.LOGIN.PROFILE' | translate}}</span></a>

      <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"><i
      class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i> <span
    class="align-middle" key="t-logout">{{ 'HEADER.LOGIN.LOGOUT' | translate}}</span></a>
  </div>
</div>

<!-- <div class="dropdown d-inline-block">
<button type="button" class="btn header-item noti-icon right-bar-toggle waves-effect"
  (click)="toggleRightSidebar()">
  <i class="bx bx-cog bx-spin"></i>
</button>
</div> -->

</div>
</div>
</header>



<p-dialog (onHide)="closeDialog()" [(visible)]="userDialog" [style]="{width: '80%'}" header="Profile Details" [modal]="true" styleClass="p-fluid" [resizable]="false" [draggable]="false">
  <ng-template pTemplate="content">
    <app-user-modal (closeDialogonChange)="closeDialog($event)"  [(roles)]="roles" [(user)]="user"  [profile]="true"></app-user-modal>
  </ng-template>

</p-dialog>